import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
   Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  TextField,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import { ChevronLeft, ChevronRight, ExpandMore } from "@mui/icons-material";
import DocumentPreview from "../components/Documents";
import ExtractedData from "../components/ExtractData";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

import ThumbIcon from "../icon/thumb.png";  // 👍 your uploaded image
import CheckIcon from "../icon/check.png";  // ✅ your uploaded image

const Creditmanagment = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5); // demo value
  const [selectedValue, setSelectedValue] = useState("LOS20250818001");
  const [collapsed, setCollapsed] = useState(true);

  // 🔹 Track which PDF should be displayed
  const [selectedPdf, setSelectedPdf] = useState("/state.pdf");

  // Responsive breakpoints
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // < 600px
  const isTablet = useMediaQuery(theme.breakpoints.down('md')); // < 900px
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg')); // < 1200px
  const [openPopup, setOpenPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState(""); // "saved" | "applied"

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  // const handlePageClick = (page) => {
  //   setCurrentPage(page);
  // };

    const handleChangePage = (event, newPage) => {
  if (newPage >= 1 && newPage <= totalPages) {
    setCurrentPage(newPage);
  }
};

  // 🔹 Change PDF when dropdown changes
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    switch (value) {
      case "LOS20250818001":
        setSelectedPdf("/state.pdf");
        break;
      case "LOS20250818002":
        setSelectedPdf("/state1.pdf");
        break;
      case "LOS20250818003":
        setSelectedPdf("/state2.pdf");
        break;
      default:
        setSelectedPdf("/state.pdf");
    }

    setCurrentPage(1); // reset to first page when switching
  };
  
const handlePdfChange = (value) => {
  switch (value) {
    case "LOS20250818001":
      setSelectedPdf("/state.pdf");
      break;
    case "LOS20250818002":
      setSelectedPdf("/state1.pdf");
      break;
    case "LOS20250818003":
      setSelectedPdf("/state2.pdf");
      break;
    default:
      setSelectedPdf(null); // no PDF if invalid
  }
  setCurrentPage(1);
};


  // Generate page numbers to display - responsive version
  const getVisiblePages = () => {
    const pages = [];
    const maxVisible = isMobile ? 3 : isTablet ? 4 : 5; // Fewer pages on mobile

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }

    return pages;
  };

  // 🔹 FIXED: Updated showPopup function to accept type parameter
  const showPopup = (message, type = "saved") => {
    setPopupMessage(message);
    setPopupType(type); // 🔹 Set the popup type
    setOpenPopup(true);

    // auto-close after  sec
    setTimeout(() => {
      setOpenPopup(false);
    }, 15000);
  };

  return (
    <Box
      sx={{
        display: "flex",
        fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
        bgcolor: "#fff",
        height: "100vh",
        overflow: { xs: "auto", md: "hidden" }, 
       
      }}
    >
      {/* Sidebar - Auto-collapse on mobile */}
       <Sidebar collapsed={collapsed}   onToggleSidebar={() => setCollapsed(!collapsed)}/>

      {/* Main Content with Header */}
      <Box sx={{ flexGrow: 1, minWidth: 0 }}> {/* minWidth: 0 prevents overflow */}
        <Header 
           
          collapsed={collapsed} 
        />

        {/* Page Content */}
        <Box sx={{ 
          p: { xs: 2, sm: 3 }, 
          pb: 2, 
          bgcolor: "#fff" 
        }}>
         
          {/* Main Header Section */}
          {/* Main Header Section */}
<Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: "center", // keep aligned
    justifyContent: "space-between", // ✅ instead of space-between
    gap: 2,
    mt: { xs: "2rem", sm: "3rem", md: "3.5rem" },
    mb: 1,
  }}
>
  {/* Left Column: Application Detail + Application Number */}
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
    }}
  >
    {/* Application Detail */}
    <Typography
      variant={isMobile ? "h6" : "h5"}
      sx={{
        fontWeight: 600,
        color: "#2e4258",
        fontSize: { xs: "1.25rem", sm: "1.5rem" },
      }}
    >
      Bureau Details
    </Typography>

    {/* Application Number Dropdown */}
    <Autocomplete
  options={[
    "LOS20250818001",
    "LOS20250818002",
    "LOS20250818003",
  ]}
  value={selectedValue || null}
  onChange={(event, newValue) => {
    setSelectedValue(newValue);
    handlePdfChange(newValue);
  }}
  onInputChange={(event, newInputValue, reason) => {
    // only run when user types or presses Enter
    if (reason === "input" || reason === "reset") {
      handlePdfChange(newInputValue);
    }
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Search Application..."
      variant="outlined"
      size="small"
      sx={{
        minWidth: { xs: "100%", sm: 220 },
        width: { xs: "100%", sm: 240 },
        boxShadow: "0px 2px 6px rgba(0,0,0,0.08)",
        fontSize: { xs: 14, sm: 14 },
        backgroundColor: "white",
        borderRadius: "10px",
        "& .MuiOutlinedInput-root": {
          "& fieldset": { border: "none" },
          "&:hover fieldset": { border: "none" },
          "&.Mui-focused fieldset": { border: "none" },
        },
      }}
    />
  )}
/>




   
  </Box>

  
{/* ✅ Raksha Solar House stays right next to Application */}  
<Card
  sx={{
    height: 60,
    borderRadius: 2,
    boxShadow: 2,
    transition: "all .2s ease",
    "&:hover": {
      boxShadow: 4,
      transform: "scale(1.03)",
    },
    p: 1.5,
    // mt: 3, // 🔹 margin top added
  }}
>
  <CardContent
    sx={{
      display: "flex",
      alignItems: "center",
      height: "100%",
      justifyContent: "center",
      p: "0 !important",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {/* First letter in round shape */}
      <Box
        sx={{
          width: 50,
          height: 50,
          borderRadius: "50%", // round shape
          bgcolor: "#4318FF1A",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          sx={{ color: "#2B3674" }}
        >
          R
        </Typography>
      </Box>

      {/* Text content */}
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Typography variant="h6" fontWeight={700} color="#2B3674">
          Raksha Solar House
        </Typography>
      </Box>
    </Box>
  </CardContent>
</Card>




</Box>

        
        </Box>

        {/* Main Content - Two separate equal sections */}
        <Box
          sx={{
            height: { 
              xs: "auto", 
              sm: "auto", 
              md: "calc(100vh - 280px)" 
            },
            minHeight: { xs: "100vh", sm: "80vh", md: "430px" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            px: { xs: 2, sm: 3 },
            gap: { xs: 3, sm: 3, md: 3 },
            bgcolor: "#fff",
            position: "relative",
            mt:-1,
          }}
        >
          {/* Document Preview Section - Separate Container */}
          <Box sx={{ 
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: { xs: "50vh", sm: "45vh", md: "100%" },
            minHeight: { xs: "50vh", sm: "45vh", md: "430px" },
            maxHeight: { xs: "50vh", sm: "45vh", md: "100%" },
            bgcolor: "white",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            overflow: "hidden",
            border: "1px solid #e0e0e0"
          }}>
            <DocumentPreview
              currentPage={currentPage}
              file={selectedPdf} // 🔹 dynamic file
              setTotalPages={setTotalPages}
            />
          </Box>
          
          {/* Extracted Data Section - Separate Container */}
          <Box sx={{ 
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: { xs: "50vh", sm: "45vh", md: "100%" },
            minHeight: { xs: "50vh", sm: "45vh", md: "430px" },
            maxHeight: { xs: "50vh", sm: "45vh", md: "100%" },
            bgcolor: "white",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            overflow: "hidden",
            border: "1px solid #e0e0e0"
          }}>
            <ExtractedData />
          </Box>
        </Box>

        {/* Bottom Section: Pagination + Buttons - Stack on mobile */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "center", sm: "space-between" },
            alignItems: "center",
            gap: { xs: 2, sm: 0 },
            p: { xs: 2, sm: 2 },
            mt: { xs: 2, sm: 3.5 },
            bgcolor: "#f5f6fa",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          {/* Pagination Controls */}
         
<Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
  {/* First page button */}
  <IconButton
    size="small"
    onClick={() => handleChangePage(null, 1)}
    disabled={currentPage === 1}
    sx={{
      minWidth: 32,
      height: 32,
      border: "1px solid #d0d7de",
      borderRadius: "4rem",
      "&:hover": { backgroundColor: "#f6f8fa" },
      "&:disabled": { opacity: 0.5 },
    }}
  >
    <Typography variant="caption">{"<<"}</Typography>
  </IconButton>

  {/* Previous page button */}
  <IconButton
    size="small"
    onClick={() => handleChangePage(null, currentPage - 1)}
    disabled={currentPage === 1}
    sx={{
      minWidth: 32,
      height: 32,
      border: "1px solid #d0d7de",
      borderRadius: "4rem",
      "&:hover": { backgroundColor: "#f6f8fa" },
      "&:disabled": { opacity: 0.5 },
    }}
  >
    <Typography variant="caption">{"<"}</Typography>
  </IconButton>

  {/* Page numbers */}
  {Array.from({ length: Math.min(totalPages, 5) }, (_, index) => {
    let pageNumber;
    if (totalPages <= 5) {
      pageNumber = index + 1;
    } else if (currentPage <= 3) {
      pageNumber = index + 1;
    } else if (currentPage >= totalPages - 2) {
      pageNumber = totalPages - 4 + index;
    } else {
      pageNumber = currentPage - 2 + index;
    }

    return (
      <IconButton
        key={pageNumber}
        size="small"
        onClick={() => handleChangePage(null, pageNumber)}
        sx={{
          minWidth: 32,
          height: 32,
          border: "1px solid #d0d7de",
          borderRadius: "4rem",
          backgroundColor: currentPage === pageNumber ? "#2e4258" : "transparent",
          color: currentPage === pageNumber ? "white" : "#24292f",
          "&:hover": {
            backgroundColor: currentPage === pageNumber ? "#2e4258" : "#f6f8fa",
          },
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          {pageNumber}
        </Typography>
      </IconButton>
    );
  })}

  {/* Show ellipsis and last page if needed */}
  {totalPages > 5 && currentPage < totalPages - 2 && (
    <>
      <Typography variant="caption" sx={{ px: 1, color: "#656d76" }}>
        ...
      </Typography>
      <IconButton
        size="small"
        onClick={() => handleChangePage(null, totalPages)}
        sx={{
          minWidth: 32,
          height: 32,
          border: "1px solid #d0d7de",
          borderRadius: "4rem",
          "&:hover": { backgroundColor: "#f6f8fa" },
        }}
      >
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          {totalPages}
        </Typography>
      </IconButton>
    </>
  )}

  {/* Next page button */}
  <IconButton
    size="small"
    onClick={() => handleChangePage(null, currentPage + 1)}
    disabled={currentPage === totalPages}
    sx={{
      minWidth: 32,
      height: 32,
      border: "1px solid #d0d7de",
      borderRadius: "4rem",
      "&:hover": { backgroundColor: "#f6f8fa" },
      "&:disabled": { opacity: 0.5 },
    }}
  >
    <Typography variant="caption">{">"}</Typography>
  </IconButton>

  {/* Last page button */}
  <IconButton
    size="small"
    onClick={() => handleChangePage(null, totalPages)}
    disabled={currentPage === totalPages}
    sx={{
      minWidth: 32,
      height: 32,
      border: "1px solid #d0d7de",
      borderRadius: "4rem",
      "&:hover": { backgroundColor: "#f6f8fa" },
      "&:disabled": { opacity: 0.5 },
    }}
  >
    <Typography variant="caption">{">>"}</Typography>
  </IconButton>
</Box>

          

          {/* Action Buttons - Full width on mobile */}
          <Box sx={{ 
            display: "flex", 
            gap: 1,
            order: { xs: 1, sm: 2 },
            width: { xs: "100%", sm: "auto" },
            justifyContent: { xs: "stretch", sm: "flex-end" }
          }}>
            {currentPage === 1 ? (
              <Button
                variant="contained"
                sx={{
                  px: { xs: 3, sm: 2.5 },
                  py: { xs: 1.5, sm: 1 },
                  textTransform: "none",
                  fontSize: { xs: "16px", sm: "14px" },
                  backgroundColor: "#1976d2",
                  flex: { xs: 1, sm: "none" },
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
                onClick={() => {
                  handleNextPage();
                  showPopup("Changes saved successfully!", "saved");
                }}
              >
                Confirm & Continue
              </Button>
            ) : currentPage < totalPages ? (
              <>
                <Button
                  variant="outlined"
                  onClick={handlePrevPage}
                  sx={{
                    px: { xs: 3, sm: 2.5 },
                    py: { xs: 1.5, sm: 1 },
                    textTransform: "none",
                    fontSize: { xs: "16px", sm: "14px" },
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    flex: { xs: 1, sm: "none" },
                    "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                  }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    px: { xs: 3, sm: 2.5 },
                    py: { xs: 1.5, sm: 1 },
                    textTransform: "none",
                    fontSize: { xs: "16px", sm: "14px" },
                    backgroundColor: "#1976d2",
                    flex: { xs: 1, sm: "none" },
                    "&:hover": { backgroundColor: "#1565c0" },
                  }}
                  onClick={() => {
                    handleNextPage();
                    showPopup("Changes saved successfully!", "saved");
                  }}
                >
                  Confirm & Continue
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  onClick={handlePrevPage}
                  sx={{
                    px: { xs: 3, sm: 2.5 },
                    py: { xs: 1.5, sm: 1 },
                    textTransform: "none",
                    fontSize: { xs: "16px", sm: "14px" },
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    flex: { xs: 1, sm: "none" },
                    "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                  }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    px: { xs: 3, sm: 2.5 },
                    py: { xs: 1.5, sm: 1 },
                    textTransform: "none",
                    fontSize: { xs: "16px", sm: "14px" },
                    backgroundColor: "#4caf50",
                    flex: { xs: 1, sm: "none" },
                    "&:hover": { backgroundColor: "#388e3c" },
                  }}
                  onClick={() => {
                    showPopup("Changes applied successfully!", "applied");
                  }}
                >
                  Confirm
                </Button>
              </>
            )}
          </Box>
        </Box>

        
      </Box>

      {/* 🔹 UPDATED DIALOG WITH CONDITIONAL STYLING */}
      <Dialog
        open={openPopup}
        onClose={() => setOpenPopup(false)}
        BackdropProps={{ 
          style: { backgroundColor: "rgba(0,0,0,0.1)" } // Light backdrop
        }}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            p: 0,
            minWidth: { xs: 300, sm: 380 },
            maxWidth: 400,
            display: "flex",
            alignItems: "stretch",
            gap: 0,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            border: "1px solid #e5e7eb",
            position: "relative",
            overflow: "hidden",
          },
        }}
      >
        {/* Main Content Container */}
        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          gap: 3, 
          p: 3,
          pr: 5, // Extra padding for close button
          width: "100%"
        }}>
          {/* Left Icon Container */}
          <Box
            sx={{
            width: 48,
            height: 48,
            borderRadius: "12px",
            backgroundColor: popupType === "saved" ? "#FFEA9F" : "#C4F4D0", // Yellow for thumb, Green for check
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
          >
            <Box
              component="img"
              src={popupType === "saved" ? ThumbIcon : CheckIcon}
              alt={popupType === "saved" ? "thumb-icon" : "success-icon"}
              sx={{ 
                width: 42, 
                height: 35,
                // filter: "brightness(0) invert(1)" // Make icon white
              }}
            />
          </Box>

          {/* Message Content */}
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ 
              fontWeight: 700, 
              fontSize: "18px", 
              color: "#111827",
              lineHeight: 1.3,
              mb: 0.5
            }}>
              {popupMessage}
            </Typography>
            <Typography sx={{ 
              fontSize: "14px", 
              color: "#6b7280",
              lineHeight: 1.4
            }}>
              {popupType === "saved"
                ? "Your work is saved. Keep going!"
                : "Go back to Home page."}
            </Typography>
          </Box>
        </Box>

        {/* Close Button - Positioned absolutely */}
        <IconButton 
          onClick={() => setOpenPopup(false)} 
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            width: 32,
            height: 32,
            color: "#9ca3af",
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "#f3f4f6",
              color: "#6b7280"
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Dialog>
    </Box>
  );
};

export default Creditmanagment;